import {
    DeleteOutlined,
    DisconnectOutlined,
    MailOutlined,
    MoonOutlined,
    RightOutlined,
    SyncOutlined,
    UserOutlined,
} from "@ant-design/icons";
import { Button, Divider, Switch } from "antd";
import styled, { css } from "styled-components";

import FlexContainer from "@/components/FlexContainer";

export const StyledUserSettings = styled(FlexContainer)`
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    width: 100%;
    gap: 12px;
`;

export const StyledContainerAccount = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 12px;
    border-bottom: 1px solid ${({ theme }) => theme.secondaryBorderColor};
    padding-bottom: 16px;
`;

export const StyledTwoColumnsGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding-top: 16px;
    gap: 12px;
    align-items: center;
`;

export const StyledButton = styled(Button)`
    height: 50px;
    border-radius: 50px;
    width: 100%;
    font-size: 16px;
    margin-top: 10px;
`;

export const StyledSwitch = styled(Switch)`
    width: fit-content;
    margin-left: auto;
`;

const iconSize = css`
    font-size: 16px;
`;

export const StyledDeleteOutlined = styled(DeleteOutlined)`
    ${iconSize}
`;

export const StyledDisconnectOutlined = styled(DisconnectOutlined)`
    ${iconSize}
`;

export const StyledMailOutlined = styled(MailOutlined)`
    ${iconSize}
`;

export const StyledMoonOutlined = styled(MoonOutlined)`
    ${iconSize}
`;

export const StyledRightOutlined = styled(RightOutlined)`
    ${iconSize};
    margin: auto;
`;

export const StyledUserOutlined = styled(UserOutlined)`
    ${iconSize}
`;

export const StyledSyncOutlined = styled(SyncOutlined)`
    ${iconSize}
`;

export const StyledDivider = styled(Divider)`
    margin-top: 10px;
    margin-bottom: 10px;
`;
